import * as React from 'react';

import Tooltip from '../tooltip';
import LabelPrimitive from './LabelPrimitive';

var StandardLabel = function StandardLabel(_ref) {
    var children = _ref.children,
        labelContent = _ref.labelContent,
        tooltip = _ref.tooltip;

    var label = React.createElement(
        LabelPrimitive,
        { labelContent: labelContent },
        children
    );

    return tooltip ? React.createElement(
        Tooltip,
        { position: 'top-right', text: tooltip },
        label
    ) : label;
};

StandardLabel.propTypes = {
    children: PropTypes.node.isRequired,
    labelContent: PropTypes.node.isRequired,
    tooltip: PropTypes.node
};
export default StandardLabel;
import PropTypes from 'prop-types';